<template>
	<Row id="custom-row">
		<div class="xl:container gap-[80px]">
			<Layout>
				<header class="entry-header">
					<h1
						ref="pageTitleRef"
						class="entry-title"
					/>
				</header>
				<div
					ref="contentRef"
					class="content"
				/>
			</Layout>
		</div>
	</Row>
</template>
<script setup>
import { ref, onMounted } from "vue";
import Layout from "~/components/layout/Legal.vue";

const $config = useRuntimeConfig();
let pageContent = null;
let pageTitle = null;

const pageTitleRef = ref(null);
const contentRef = ref(null);

const $route = useRoute();
const { current_hostname } = useRuntimeConfig().public;
const pageSlug = $route.name;

const fetchData = async () => {
	try {
		const response = await $fetch(`${$config.public.hostname}graphql`, {
			method: "post",
			body: {
				query: `
					query newQuery {
						pageBy(uri: "/cookie-policy/") {
						title
						pageId
						content
						date
						dateGmt
						featuredImage {
							node {
							sourceUrl
							uri
							author {
								node {
								firstName
								id
								avatar {
									url
									size
								}
								description
								lastName
								name
								}
							}
							}
						}
						${SEO_QUERY}
						}
					}`
			}
		});

		setupSEO(response.data.pageBy.saswpSchema.json_ld);
		pageContent = replaceLinks(response.data.pageBy.content);
		pageTitle = response.data.pageBy.title;
		pageTitleRef.value.innerHTML = pageTitle;
		contentRef.value.innerHTML = replaceLinks(response.data.pageBy.content);
		checkForTocTitle();
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e);
	}
};

const setupSEO = (doc) => {
	const script = document.createElement("script");
	script.type = "application/ld+json";
	const jsonString = JSON.stringify(doc);
	const cleanedJSON = jsonString
		.replace(/\\\"/g, '"')
		.replace(/\\\\/g, "\\")
		.replace(
			/https:\/\/content\.timothysykes\.com\/?/g,
			"https://www.timothysykes.com/"
		);
	script.text = cleanedJSON;
	document.head.appendChild(script);
};

const checkForTocTitle = () => {
	if (pageContent) {
		const tocTitles = document.querySelectorAll(".toc_title");
		const toc = document.querySelector(".toc_list");

		if (tocTitles.length > 0) {
			tocTitles.forEach((tocTitle) => {
				const button = document.createElement("button");
				button.setAttribute("aria-label", "Toggle Table of Contents");
				button.innerHTML = `
					<span class="expand"> 
						<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12.5" cy="12.5" r="11.5" fill="#3094FB" stroke="#FCFCFD" stroke-width="2"/>
						<path d="M12.5 7.5V17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
						<path d="M7.5 12.5H17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
						</svg>
					</span>
					<span class="collapse"> 
						<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12.5" cy="12.5" r="11.5" fill="#3094FB" stroke="#FCFCFD" stroke-width="2"/>
						<path d="M7.5 12.5H17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
						</svg>
					</span>`;

				button.addEventListener("click", function () {
					if (toc.classList.contains("active")) {
						button.classList.remove("active");
						toc.classList.remove("active");
					} else {
						button.classList.add("active");
						toc.classList.add("active");
					}
				});
				tocTitle.appendChild(button);
			});
		}
	}
};

const replaceLinks = (content) => {
	if (content) {
		const regex = /https:\/\/content\.timothysykes\.com/g;
		return content.replace(regex, "https://www.timothysykes.com");
	}
	return content;
};

onMounted(() => {
	fetchData().then(() => {
		useHead(() => {
			return {
				title: `${pageTitle} - Timothy Sykes`,
				link: [{ rel: "canonical", href: `${current_hostname}${pageSlug}/` }]
			};
		});
	});
});
</script>
<style lang="scss">
@import "../assets/utils.scss";

#custom-row {
	display: block;

	@include breakpoint(lg) {
		display: flex;
	}
}

#custom-row #toc_container .toc_title {
	margin-bottom: 0;
}

#custom-row .content p {
	margin-bottom: 32px;
}

#custom-row .content .toc_list a {
	color: #fff;
}

#custom-row #toc_container ul li {
	font-weight: 600;
}

#custom-row ol li {
	padding-left: 8px;
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row ol li::marker {
	content: "■";
	color: #3b82f6;
}

#custom-row ol li ol li::marker {
	content: "■";
	color: #1e3a8a;
}

#custom-row td {
	padding: 8px 8px;
	border: 1px solid #000;
}

#custom-row p strong {
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row .content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}
#custom-row .content a {
	color: #3b82f6;
}

#custom-row .content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}
</style>
